export default __webpack_public_path__ + "static/media/black_king.fe2d4e5b.png";